import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { referralChangeStatus, referralList } from "../../../store/actions/referralAction";
import { Dropdown, Input} from "antd";
import { dateFormat, MaskEmail, MaskPhoneNumber } from "../../../utils/helper";
import TableWrapper from "../../../components/Tables";
import Pagination from "../../../components/Pagination";
import axios from "axios";
import { EditFilled, PauseCircleFilled, CaretRightOutlined, FilterOutlined, DownOutlined, CalendarOutlined, RetweetOutlined } from '@ant-design/icons';

const ReferralsIndex = () => {
  const [search, setsearch] = useState("");
  const [sourceFilter, setSourceFilter] = useState()
  const [statusfilter, setStatusFilter] = useState()
  const [startDatefilter, setStartDateFilter] = useState()
  const [endDatefilter, setEndDateFilter] = useState()
  let dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    dispatch(referralList(1, search, sourceFilter, statusfilter, startDatefilter, endDatefilter))
  }, [dispatch, search, sourceFilter, statusfilter, startDatefilter, endDatefilter]);

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name === "Super Admin") return;
    if (!userInfo.permission.includes("referrals-read")) history.push("/403");
  }, [userInfo, history]);

  const dataReferralList = useSelector((state) => state.referralList);
  const { referral, listsReferral } = dataReferralList;

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(referralList(1, search, sourceFilter, statusfilter, startDatefilter, endDatefilter));
  };

  const handleChangeStatus = async (id, status) => {
    await referralChangeStatus(id, status)
    dispatch(referralList(1, search));
  }

  const handleResetFilter = () => {
    setStartDateFilter(null)
    setEndDateFilter(null)
    setStatusFilter(null)
    setSourceFilter(null)
  }

  const handleExportToExcel = async () => {
    try {
      const response = await axios.get("referral/export-to-excel", {
        responseType: 'blob',
      });
    
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'referrals.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Export failed:", error);
    }    
  }

  const sourceFilterList = ["facebook", "instagram", "twitter", "tiktok"]
  const sourceItems = sourceFilterList.map((e) => ({
    key: e,
    label: (
      <div onClick={() => setSourceFilter(e)}>
        {e}
      </div>
    ),
  }));

  const statusFilterList = ["active", "inactive"]
  const statusItems = statusFilterList.map((e) => ({
    key: e,
    label: (
      <div onClick={() => setStatusFilter(e)}>
        {e}
      </div>
    ),
  }));

  const tableHead = [
    { name: "No" },
    { name: "Name" },
    { name: "Status" },
    { name: "Phone Number" },
    { name: "Email" },
    { name: "Registration" },
    { name: "Source" },
    { name: "Total Referrals" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.name },
    { render: (item) => 
      <span className={`badge badge-${item.status ? "success" : "danger"}`}>
        {item.status ? "Active" : "Inactive"}
      </span>
    },
    { render: (item) => <MaskPhoneNumber item={item} /> },
    { render: (item) => <MaskEmail item={item} /> },
    { render: (item) => dateFormat(item.registration) },
    { render: (item) => item.utm_source?.utm_source ?? "-" },
    { render: (item) => item.total_referrals},
    {
      render: (item) => (
        <div className="d-flex">
          <span 
            onClick={(e) => e.stopPropagation()} 
            onMouseDown={(e) => e.stopPropagation()}
          >
            <Link to={`/referrals-edit/${item.id}`} className="btn btn-warning mx-1 btn-sm">
              <EditFilled className="mr-1"/> Edit
            </Link>
          </span>
          {
            item.status ?
              <button type="button" class="btn btn-danger mx-1 btn-sm" onClick={() => handleChangeStatus(item.id, false)}><PauseCircleFilled className="mr-1"/> Deactivate</button> :
              <button type="button" class="btn btn-success mx-1 btn-sm" onClick={() => handleChangeStatus(item.id, true)}><CaretRightOutlined className="mr-1"/> Activate</button>
          }
        </div>
      )
    }
  ];

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Referrals</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12 overflow-hidden">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-sm-12 d-flex justify-content-end mb-2"><button type="button" class="btn btn-success px-5 btn-sm" onClick={handleExportToExcel}>Export</button></div>
                <div className="col-sm-9 col-xs-12">
                  <div className="col-md-11 col-sm-12 d-flex justify-content-center flex-wrap">
                    <Dropdown 
                      menu={{ items: sourceItems }} 
                      trigger={['click']} 
                      placement="bottomLeft"
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <FilterOutlined className="text-dark"/>
                        <span>{sourceFilter ?? "All Source"}</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>

                    <Dropdown 
                      dropdownRender={() => (
                          <div className="bg-white shadow p-2 d-flex flex-column">
                            <div className="d-flex mb-3">
                              <label style={{width: "50px"}}>Start</label>
                              <Input type="date" value={startDatefilter} onChange={(e) => setStartDateFilter(e.target.value)} />
                            </div>

                            <div className="d-flex mb-3">
                              <label style={{width: "50px"}}>end</label>
                              <Input type="date" value={endDatefilter} onChange={(e) => setEndDateFilter(e.target.value)} />
                            </div>

                            <button className="btn btn-info btn-sm rounded-pill" onClick={() => dispatch(referralList(1, search, sourceFilter, statusfilter, startDatefilter, endDatefilter))}>Apply</button>
                          </div>
                        )}
                      trigger={['click']} 
                      placement="bottomLeft"
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <CalendarOutlined className="text-dark"/>
                        <span>{
                        startDatefilter && endDatefilter ? `${startDatefilter} - ${endDatefilter}`  : 
                        startDatefilter ? `Start: ${startDatefilter}` :
                        endDatefilter ? `End: ${endDatefilter}` :
                        "All Dates"
                        }</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>

                    <Dropdown 
                      menu={{ items: statusItems }} 
                      trigger={['click']} 
                      placement="bottomLeft"
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <FilterOutlined className="text-dark"/>
                        <span>{statusfilter ?? "All Status"}</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>
                  </div>

                  <div className="col-md-1 col-sm-12 d-flex justify-content-center">
                    <button 
                      type="button" 
                      style={{ height: "30px" }} 
                      className="btn btn-outline-info btn-sm rounded-pill px-3 text-dark d-flex justify-content-between align-items-center"
                      onClick={handleResetFilter}
                    >
                      <RetweetOutlined className="text-dark"/>
                    </button>
                  </div>
                </div>
                <div className="col-sm-3 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "100%", textOverflow: "ellipsis", paddingRight: "40px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link h-auto"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper 
                datas={listsReferral}
                tableHead={tableHead}
                tableBody={tableBody}
                rowLink={"referrals-detail"}
              />
              <Pagination
                datas={referral}
                listsData={referralList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralsIndex;
